import React from "react";

const RepairAccountsCard = ({ title, btn_text, desc, icons, status }) => {
  return (
    <div className="card">
      <div className="header_area">
        <h4>
          <input type="checkbox" className="checkBox" />
          {title}
        </h4>
        <button className="btn">{btn_text}</button>
      </div>
      <p className="mt-2">{desc}</p>
      <hr className="mt-4" />
      <div className="mt-3">
        <p className="status">
          {icons} {status}
        </p>
      </div>
    </div>
  );
};

export default RepairAccountsCard;
